/* eslint-disable @next/next/no-img-element */
'use client'
import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { IoLocationSharp } from 'react-icons/io5'
import { CgPhone } from 'react-icons/cg'
import { MdEmail } from 'react-icons/md'
import { Row, Col } from 'react-bootstrap'
import supportIcon from '@/assets/icon/support.png'
import AppleImage from '@/assets/download-app/apple.webp'
import GoogleImage from '@/assets/download-app/google.webp'
import LinearGrediantLogo from '@/assets/LinearGrediantLogo'
import MbFooterLogo from '@/assets/footer-mb.png'
import { ReactGAEvent } from '@/components/ReactGAs'
import '@/styles/css/components/footer.scss'
import { HiOutlineIdentification } from 'react-icons/hi2'

const Footer = () => {
	const socialMediaHandler = (event, action = 'Social Media click', label = 'Blank') => {
		ReactGAEvent({ action: action, event: event, label: label, category: 'Footer' })
	}

	return (
		<footer>
			<Row className='align-items-center mb-5 footer-links'>
				<Col md={4}>
					<div className='d-flex flex-column gap-3 address'>
						<div className='d-flex gap-2 align-items-center'>
							{/* <Logo /> */}
							<Image width={54} height={51} src={MbFooterLogo} alt='mb-logo' />
							<LinearGrediantLogo />
						</div>
						<div className='d-flex flex-column gap-2 footer-addr-contact'>
							<Link
								href='https://www.google.com/maps/search/4th+Floor,+406,+Lakshmi+Bhawan,+Nehru+Place,+New+Delhi+110019./@28.548814,77.2510648,18z?entry=ttu'
								target='_blank'
								className='d-flex align-items-start'
							>
								<IoLocationSharp size='24' fill='#fff' />
								<h6>HQ : 4th Floor, 406, Lakshmi Bhawan, Nehru Place, New Delhi 110019, India.</h6>
							</Link>
							<Link
								href='https://www.google.com/maps/place/Metalbook/@28.5204637,77.178666,14z/data=!4m2!3m1!1s0x0:0xa533857104f8672?sa=X&amp;ved=2ahUKEwj1urylleT5AhU963MBHYAIAyAQ_BJ6BAhmEAY'
								target='_blank'
								className='d-flex align-items-start'
							>
								<IoLocationSharp size='24' fill='#fff' />
								<h6>Corp : 3rd Floor, Tejaswi Impex Pvt. Ltd , Sector 44, Gurugram, Haryana - 122003, India.</h6>
							</Link>

							<div>
								<h6>
									<HiOutlineIdentification size='24' color='#fff' />
									 CIN - U51900DL2020PTC375107
								</h6>
							</div>

							<div>
								<CgPhone size='24' color='#fff' />
								<a href='tel:919811714120' target='_blank'>
									9811714120
								</a>
								,{' '}
								<a href='tel:917838767136' target='_blank'>
									7838767136
								</a>
							</div>

							<Link href='mailto:contact@metalbook.com' target='_blank' className='d-flex'>
								<MdEmail size='24' fill='#fff' />
								<p>contact@metalbook.com</p>
							</Link>
						</div>
						<Row className='d-flex justify-content-start'>
							<Col xs={6} lg={5}>
								<a
									href='https://apps.apple.com/in/app/metalbook/id6450207151'
									target='_blank'
									onClick={() => {
										socialMediaHandler('download_ios_app', 'Download our app', 'App download')
									}}
								>
									<Image src={AppleImage} alt='appstore' />
								</a>
							</Col>
							<Col xs={6} lg={5}>
								<a
									href='https://play.google.com/store/apps/details?id=app.metalbook'
									target='_blank'
									onClick={() => {
										socialMediaHandler('download_android_app', 'Download our app', 'App download')
									}}
								>
									<Image src={GoogleImage} alt='play store' />
								</a>
							</Col>
						</Row>
					</div>
				</Col>
				<Col md={4}>
					<Row className='g-1'>
						<Col xs={6}>
							<ul className='link-list'>
								<li>
									<Link href='/buying'>Buying</Link>
								</li>
								<li>
									<Link href='/selling'>Selling</Link>
								</li>
								<li>
									<Link href='/metal-fabrication'>Fabrication</Link>
								</li>
								<li>
									<Link href='/finance'>Finance</Link>
								</li>
								<li>
									<Link href='/logistics'>Logistics</Link>
								</li>
								<li>
									<Link href='/glossary'>Glossary</Link>
								</li>
								<li>
									<Link href='/commodity-prices'>Commodity Prices</Link>
								</li>
								{/* commodity-prices */}
							</ul>
						</Col>
						<Col xs={6}>
							<ul className='link-list'>
								<li>
									<Link href='/products'>Products</Link>
								</li>
								<li>
									<Link href='/about-us'>About Us</Link>
								</li>
								<li>
									<Link href='/careers'>Careers</Link>
								</li>
								<li>
									<Link href='/blogs'>Blogs</Link>
								</li>
								<li>
									<Link href='/terms-and-conditions'>T&C</Link>
								</li>
								<li>
									<Link href='/privacy-policy'>Privacy Policy</Link>
								</li>
							</ul>
						</Col>
					</Row>
				</Col>
				<Col className='join-metalbook-wapper' md={4}>
					<div className='join-metalbook'>
						<Image src={supportIcon} alt='support-icon' />
						<h2 className='text-1'>Join Metalbook</h2>
						<p className='text-2'>
							Discover how Metalbook can help your business to remove all mundane tasks so you can focus only on business.
						</p>
						<a className='btn btn-primary w-100 border-0' href='https://calendly.com/metalbook/metalbook-live-demo' target='_blank'>
							Schedule a Demo
						</a>
					</div>
				</Col>
			</Row>
			<div className='border-top pt-4 row d-flex'>
				<Col md={10} xs={12} className='mb-3'>
					©{ new Date().getFullYear() } Mbook Technology Pvt Ltd. All Rights Reserved.
				</Col>
				<Col md={2} xs={12}>
					<div className='footer-link'>
						<a
							href='https://www.facebook.com/metalbook.in'
							target='_blank'
							onClick={() => {
								socialMediaHandler('view_facebook')
							}}
						>
							<svg xmlns='http://www.w3.org/2000/svg' width={20} height={21} viewBox='0 0 20 21' fill='none'>
								<g clipPath='url(#clip0_552_3571)'>
									<path
										d='M20 10.1748C20 4.65195 15.5229 0.174805 10 0.174805C4.47715 0.174805 0 4.65195 0 10.1748C0 15.166 3.65684 19.3031 8.4375 20.0533V13.0654H5.89844V10.1748H8.4375V7.97168C8.4375 5.46543 9.93047 4.08105 12.2146 4.08105C13.3084 4.08105 14.4531 4.27637 14.4531 4.27637V6.73731H13.1922C11.95 6.73731 11.5625 7.5082 11.5625 8.2998V10.1748H14.3359L13.8926 13.0654H11.5625V20.0533C16.3432 19.3031 20 15.166 20 10.1748Z'
										fill='white'
									/>
								</g>
								<defs>
									<clipPath id='clip0_552_3571'>
										<rect width={20} height={20} fill='white' transform='translate(0 0.174805)' />
									</clipPath>
								</defs>
							</svg>
						</a>
						<a
							href='https://www.instagram.com/metal.book/'
							target='_blank'
							onClick={() => {
								socialMediaHandler('view_Instagram')
							}}
						>
							<svg xmlns='http://www.w3.org/2000/svg' width={20} height={21} viewBox='0 0 20 21' fill='none'>
								<g clipPath='url(#clip0_552_3575)'>
									<path
										d='M10 1.97559C12.6719 1.97559 12.9883 1.9873 14.0391 2.03418C15.0156 2.07715 15.543 2.24121 15.8945 2.37793C16.3594 2.55762 16.6953 2.77637 17.043 3.12402C17.3945 3.47559 17.6094 3.80762 17.7891 4.27246C17.9258 4.62402 18.0898 5.15527 18.1328 6.12793C18.1797 7.18262 18.1914 7.49902 18.1914 10.167C18.1914 12.8389 18.1797 13.1553 18.1328 14.2061C18.0898 15.1826 17.9258 15.71 17.7891 16.0615C17.6094 16.5264 17.3906 16.8623 17.043 17.21C16.6914 17.5615 16.3594 17.7764 15.8945 17.9561C15.543 18.0928 15.0117 18.2568 14.0391 18.2998C12.9844 18.3467 12.668 18.3584 10 18.3584C7.32813 18.3584 7.01172 18.3467 5.96094 18.2998C4.98438 18.2568 4.45703 18.0928 4.10547 17.9561C3.64063 17.7764 3.30469 17.5576 2.95703 17.21C2.60547 16.8584 2.39063 16.5264 2.21094 16.0615C2.07422 15.71 1.91016 15.1787 1.86719 14.2061C1.82031 13.1514 1.80859 12.835 1.80859 10.167C1.80859 7.49512 1.82031 7.17871 1.86719 6.12793C1.91016 5.15137 2.07422 4.62402 2.21094 4.27246C2.39063 3.80762 2.60938 3.47168 2.95703 3.12402C3.30859 2.77246 3.64063 2.55762 4.10547 2.37793C4.45703 2.24121 4.98828 2.07715 5.96094 2.03418C7.01172 1.9873 7.32813 1.97559 10 1.97559ZM10 0.174805C7.28516 0.174805 6.94531 0.186523 5.87891 0.233398C4.81641 0.280273 4.08594 0.452148 3.45313 0.698242C2.79297 0.956055 2.23438 1.2959 1.67969 1.85449C1.12109 2.40918 0.78125 2.96777 0.523438 3.62402C0.277344 4.26074 0.105469 4.9873 0.0585938 6.0498C0.0117188 7.12012 0 7.45996 0 10.1748C0 12.8896 0.0117188 13.2295 0.0585938 14.2959C0.105469 15.3584 0.277344 16.0889 0.523438 16.7217C0.78125 17.3818 1.12109 17.9404 1.67969 18.4951C2.23438 19.0498 2.79297 19.3936 3.44922 19.6475C4.08594 19.8936 4.8125 20.0654 5.875 20.1123C6.94141 20.1592 7.28125 20.1709 9.99609 20.1709C12.7109 20.1709 13.0508 20.1592 14.1172 20.1123C15.1797 20.0654 15.9102 19.8936 16.543 19.6475C17.1992 19.3936 17.7578 19.0498 18.3125 18.4951C18.8672 17.9404 19.2109 17.3818 19.4648 16.7256C19.7109 16.0889 19.8828 15.3623 19.9297 14.2998C19.9766 13.2334 19.9883 12.8936 19.9883 10.1787C19.9883 7.46387 19.9766 7.12402 19.9297 6.05762C19.8828 4.99512 19.7109 4.26465 19.4648 3.63184C19.2188 2.96777 18.8789 2.40918 18.3203 1.85449C17.7656 1.2998 17.207 0.956055 16.5508 0.702148C15.9141 0.456055 15.1875 0.28418 14.125 0.237305C13.0547 0.186523 12.7148 0.174805 10 0.174805Z'
										fill='white'
									/>
									<path
										d='M10 5.03809C7.16406 5.03809 4.86328 7.33887 4.86328 10.1748C4.86328 13.0107 7.16406 15.3115 10 15.3115C12.8359 15.3115 15.1367 13.0107 15.1367 10.1748C15.1367 7.33887 12.8359 5.03809 10 5.03809ZM10 13.5068C8.16016 13.5068 6.66797 12.0146 6.66797 10.1748C6.66797 8.33496 8.16016 6.84277 10 6.84277C11.8398 6.84277 13.332 8.33496 13.332 10.1748C13.332 12.0146 11.8398 13.5068 10 13.5068Z'
										fill='white'
									/>
									<path
										d='M16.5391 4.83496C16.5391 5.49903 16 6.03418 15.3398 6.03418C14.6758 6.03418 14.1406 5.49512 14.1406 4.83496C14.1406 4.1709 14.6797 3.63574 15.3398 3.63574C16 3.63574 16.5391 4.17481 16.5391 4.83496Z'
										fill='white'
									/>
								</g>
								<defs>
									<clipPath id='clip0_552_3575'>
										<rect width={20} height={20} fill='white' transform='translate(0 0.174805)' />
									</clipPath>
								</defs>
							</svg>
						</a>
						<a
							href='https://www.linkedin.com/company/metalbook-app/'
							target='_blank'
							onClick={() => {
								socialMediaHandler('view_linkedin')
							}}
						>
							<svg xmlns='http://www.w3.org/2000/svg' width={20} height={21} viewBox='0 0 20 21' fill='none'>
								<g clipPath='url(#clip0_552_3580)'>
									<path
										d='M18.5195 0.174805H1.47656C0.660156 0.174805 0 0.819336 0 1.61621V18.7295C0 19.5264 0.660156 20.1748 1.47656 20.1748H18.5195C19.3359 20.1748 20 19.5264 20 18.7334V1.61621C20 0.819336 19.3359 0.174805 18.5195 0.174805ZM5.93359 17.2178H2.96484V7.6709H5.93359V17.2178ZM4.44922 6.37012C3.49609 6.37012 2.72656 5.60059 2.72656 4.65137C2.72656 3.70215 3.49609 2.93262 4.44922 2.93262C5.39844 2.93262 6.16797 3.70215 6.16797 4.65137C6.16797 5.59668 5.39844 6.37012 4.44922 6.37012ZM17.043 17.2178H14.0781V12.5771C14.0781 11.4717 14.0586 10.0459 12.5352 10.0459C10.9922 10.0459 10.7578 11.2529 10.7578 12.499V17.2178H7.79688V7.6709H10.6406V8.97559H10.6797C11.0742 8.22559 12.043 7.43262 13.4844 7.43262C16.4883 7.43262 17.043 9.40918 17.043 11.9795V17.2178Z'
										fill='white'
									/>
								</g>
								<defs>
									<clipPath id='clip0_552_3580'>
										<rect width={20} height={20} fill='white' transform='translate(0 0.174805)' />
									</clipPath>
								</defs>
							</svg>
						</a>
						<a
							href='https://www.youtube.com/channel/UCisMPC2B8OE77_7LPsecMQQ'
							target='_blank'
							onClick={() => {
								socialMediaHandler('view_youtube')
							}}
						>
							<svg xmlns='http://www.w3.org/2000/svg' width={20} height={21} viewBox='0 0 20 21' fill='none'>
								<path
									d='M14.1665 3.50806H5.83317C3.33317 3.50806 1.6665 5.17472 1.6665 7.67472V12.6747C1.6665 15.1747 3.33317 16.8414 5.83317 16.8414H14.1665C16.6665 16.8414 18.3332 15.1747 18.3332 12.6747V7.67472C18.3332 5.17472 16.6665 3.50806 14.1665 3.50806ZM11.5749 11.0331L9.51649 12.2664C8.68316 12.7664 7.99982 12.3831 7.99982 11.4081V8.93306C7.99982 7.95806 8.68316 7.57473 9.51649 8.07473L11.5749 9.30805C12.3665 9.79138 12.3665 10.5581 11.5749 11.0331Z'
									fill='white'
								/>
							</svg>
						</a>
					</div>
				</Col>
			</div>
		</footer>
	)
}

export default Footer
